import type { IconData } from '@stacksjs/iconify-core'

export const mq4x3: IconData = {
  "body": "<path fill=\"#231f1e\" d=\"M0 0h640v480H0z\"/><path fill=\"#00a650\" d=\"M0 0h640v240H0z\"/><path fill=\"#ef1923\" d=\"m0 0l320 240L0 480z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default mq4x3
